export default __webpack_public_path__ + "static/media/webstart_diploma.93666e27.jpg";